export const money = (v, cur) =>
  cur === "inr" ? `₹${Math.round(Number(v) || 0).toLocaleString("en-IN")}` : `$${(Number(v) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const shortDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");
